// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".integration-overview {\n  text-align: left;\n  padding-left: 40px;\n}\n.integration-overview h1 {\n  display: block;\n  margin: 40px 0 48px 0;\n}\n", ""]);
// Exports
module.exports = exports;
